export const imgUrl =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

// export const logoURL =
// "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAqYVSYheUUyRpZHtaLHYAs0SmIVKtm7rmHuxp2H6J-A&s";

export const logo =
  "https://image.similarpng.com/very-thumbnail/2021/09/Good-food-logo-design-on-transparent-background-PNG.png";

// export const logoURL =
//   "https://w7.pngwing.com/pngs/47/533/png-transparent-swiggy-office-business-online-food-ordering-delivery-bangalore-business-food-text-orange-thumbnail.png";

export const api =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=17.406498&lng=78.47724389999999&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";

export const menu_api =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=17.385044&lng=78.486671&restaurantId=";

export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const VEG_ICON_IMAGE =
  "https://upload.wikimedia.org/wikipedia/commons/b/b2/Veg_symbol.svg";
export const NON_VEG_ICON_IMAGE =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Non_veg_symbol.svg/1920px-Non_veg_symbol.svg.png";
